import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

const dateOnly = /^\d{4}-\d{2}-\d{2}$/

export const formatDate = (value?: number | string): string => (value ? format(toDate(value), 'dd/MM/yyyy') : '-')

export const formatDayOfWeek = (value?: number | string): string =>
  value ? format(toDate(value), 'EEEE', { locale: ptBR }) : '-'

export const formatWeekdayDayMonthYear = (value?: number | string): string =>
  value
    ? format(toDate(value), "eeee, dd 'de' MMMM 'de' yyyy", {
        locale: ptBR,
      })
    : '-'

export const formatHoursMinutes = (value?: number | string): string => (value ? format(toDate(value), 'HH:mm') : '-')

export const toDate = (value: number | string): Date =>
  new Date(typeof value === 'string' && dateOnly.test(value) ? `${value}T00:00:00` : value)

export const formatDateAndHoursMinutes = (value?: number | string): string =>
  value ? format(toDate(value), "dd/MM/yyyy 'às' HH:mm") : '-'
